export const MOCK_BILLING_ACCOUNT_DETAILS = {
  entity: {
    _schema: 'billing_account',
    _id: 'ba-00000-0000-4000-8000-000000000001',
    _org: 'test-org',
    _created_at: '2025-06-01T10:00:00.000Z',
    _updated_at: '2026-01-15T14:30:00.000Z',
    _title: 'BA-1001',
    _acl: {
      view: ['org_test-org'],
      edit: ['org_test-org'],
      delete: ['org_test-org']
    },
    billing_account_number: 'BA-1001',
    external_id: 'EXT-BA-1001',
    balance: { amount_in_cents: 5000, currency: 'EUR' },
    billing_address: {
      street: 'Musterstraße',
      street_number: '1',
      postal_code: '80331',
      city: 'München',
      country: 'DE'
    },
    payment_method: {
      type: 'sepa_debit',
      iban: 'DE89370400440532013000',
      bic: 'COBADEFFXXX',
      bank_name: 'Commerzbank',
      account_holder_name: 'Max Mustermann'
    },
    last_invoice: '2026-01-01',
    delivery_start: '2025-06-15',
    delivery_end: null,
    installment_amount: { amount_in_cents: 8500, currency: 'EUR' },
    billing_contact: {
      $relation: [
        {
          entity_id: '6fd04058-92c9-43bc-ab10-29a2d6808be3',
          _schema: 'contact'
        }
      ]
    },
    contracts: {
      $relation: [
        {
          entity_id: 'a68e4801-979c-4fee-b43f-0dbacb06634e'
        }
      ]
    }
  },
  relations: []
}
